export enum TrdRegPublicationType {
  PreTradeTransparencyWaiver = 0,
  PostTradeDeferral = 1,
  ExemptFromPublication = 2,
  OrderLevelPublicationToSubscribers = 3,
  PriceLevelPublicationToSubscribers = 4,
  OrderLevelPublicationToThePublic = 5,
  PublicationInternalToExecutionVenue = 6,
}
